const sourceURLStorageKey = 'registration-sourceURL';

export const tryStoreSourceURL = () => {
  if (!window.location.search) return;
  try {
    const params = new URLSearchParams(window.location.search);
    const result = Object.fromEntries(params.entries());
    if (!result.sourceURL) return;
    localStorage.setItem(sourceURLStorageKey, result.sourceURL);
  } catch (e) {
    localStorage.removeItem(sourceURLStorageKey);
  }
};

export const tryReadSourceURL = () =>
  localStorage.getItem(sourceURLStorageKey) || '';

export const removeSourceURL = () =>
  localStorage.removeItem(sourceURLStorageKey);
